<script lang="ts" setup>
import CarouselPagination from '@shared/fondof-ui/components/molecules/carousel/CarouselPagination.vue'
import CarouselPaginationDots from '@shared/fondof-ui/components/molecules/carousel/CarouselPaginationDots.vue'
import { carouselDotVariants } from '@storefront-satch/components/molecules/emblaCarousel/variants'
</script>

<template>
  <CarouselPagination class="mt-4 flex w-full flex-wrap justify-center">
    <CarouselPaginationDots
      :dot-class="carouselDotVariants()"
      :dot-class-selected="
        carouselDotVariants({
          state: 'active',
        })
      "
      :dot-class-inactive="
        carouselDotVariants({
          state: 'inactive',
        })
      "
    />
  </CarouselPagination>
</template>
